import { Controller } from '@hotwired/stimulus';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

export default class extends Controller {
  static values = {
    formId: String,
    modalId: String,
    offcanvasClass: String,
  };

  connect() {
    this.modal = Modal.getInstance(document.getElementById(this.modalIdValue));

    // if form submission is always in a modal, no need for offcanvas
    if (this.hasOffcanvasClassValue) {
      this.offcanvas = Offcanvas.getInstance(document.querySelector(`.${this.offcanvasClassValue}`));
    }

    // form id can be empty if we don't need a form submission
    if (this.hasFormIdValue) {
      this.linkedForm = document.getElementById(this.formIdValue);
      this.linkedForm.addEventListener('turbo:before-fetch-response', () => {
        this.closeModal();
      }, { once: true });
    }
  }

  submitForm() {
    this.linkedForm.requestSubmit();
  }

  closeModal() {
    if (this.modal !== null) {
      this.modal.hide();
    }
  }

  closeOffcanvas() {
    if (this.offcanvas !== null) {
      this.offcanvas.hide();
    }
  }
}
